/* V25 — always-current estimate: adds business days in the Netherlands calendar.
   Dates update on every page load and hourly if the page remains open.
   No carrier data, cutoff, local/national holidays or customs estimates are used. */
(function () {
  'use strict';
  var formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Amsterdam', day: '2-digit', month: '2-digit', year: 'numeric'
  });
  function amsterdamDate() {
    var parts = formatter.formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return new Date(Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), 12, 0, 0));
  }
  function futureWorkday(base, days) {
    var date = new Date(base.getTime());
    for (var added = 0; added < days;) {
      date.setUTCDate(date.getUTCDate() + 1);
      var day = date.getUTCDay();
      if (day !== 0 && day !== 6) added++;
    }
    return date;
  }
  function prettyDate(date) {
    return new Intl.DateTimeFormat('en-GB', {timeZone:'UTC', day:'numeric', month:'short'}).format(date);
  }
  function renderOne(node) {
    var output = node.querySelector('[data-al-estimate]');
    if (!output) return;
    var match = String(node.getAttribute('data-al-business-days') || '').match(/^\s*(\d{1,2})\s*[-–]\s*(\d{1,2})\s*$/);
    if (!match) {output.textContent = 'See our shipping policy';return;}
    var minimum = Number(match[1]), maximum = Number(match[2]);
    if (minimum < 1 || maximum < minimum || maximum > 60) {output.textContent = 'See our shipping policy';return;}
    if (node.getAttribute('data-al-delivery-dates') === 'false') {
      output.textContent = minimum + '–' + maximum + ' business days';return;
    }
    var today = amsterdamDate();
    var start = futureWorkday(today,minimum), end = futureWorkday(today,maximum);
    output.textContent = prettyDate(start) + ' – ' + prettyDate(end);
    output.setAttribute('title', minimum + '–' + maximum + ' business days from order date. Estimated, not guaranteed.');
  }
  function update() {document.querySelectorAll('[data-al-delivery-widget]').forEach(renderOne);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',update);
  else update();
  document.addEventListener('shopify:section:load',update);
  // Shopify product-rerender swaps DOM on variant selection; update replacements.
  if (typeof MutationObserver !== 'undefined') {
    var pending = false;
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        return Array.prototype.some.call(r.addedNodes, function (n) {return n.nodeType === 1 &&
          ((n.matches && n.matches('[data-al-delivery-widget],product-rerender')) || (n.querySelector && n.querySelector('[data-al-delivery-widget]')));});
      });
      if (relevant && !pending) {pending=true;requestAnimationFrame(function () {pending=false;update();});}
    }).observe(document.body || document.documentElement, {childList:true,subtree:true});
  }
  setInterval(update, 60 * 60 * 1000);
})();
